import { useDispatch } from "react-redux";
import CustomButton from "../CustomButton";
import ModalLayout from "../layouts/ModalLayout";
import { useNavigate } from "react-router-dom";
import { AppDispatch } from "../../store";
import { logout } from "../../features/user/UserSlice";
import { removeLocalStorage } from "../../util/manageStorage";

interface Props {
  onClose?: () => void;
}

export default function LogoutModal({ onClose }: Props) {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const handleLogout = () => {
    dispatch(logout("Logged out successfully"));
    removeLocalStorage("selectedBranchCode");
    onClose?.();
    navigate("/login");
  };

  return (
    <ModalLayout onClose={onClose}>
      <div className="flex flex-col gap-6">
        <h4 className="text-xl font-semibold text-neutral-400">
          Are you sure you want to logout of your account?
        </h4>
        <div className="flex justify-end items-end gap-4">
          <CustomButton
            text="Stay Logged in"
            color="bg-neutral-200"
            onClick={onClose}
          />
          <CustomButton
            text="Yes, Logout"
            color="bg-error-600"
            onClick={handleLogout}
          />
        </div>
      </div>
    </ModalLayout>
  );
}
